export default __webpack_public_path__ + "static/media/programming.3dd772ea.jpeg";